import React, { useEffect, useRef, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Box } from '@material-ui/core';

import { useStores } from '../../hooks/use-stores';
import { RegisterLoc } from '../../loc/register';
import { loc } from '../../lib/loc';

import RegisterFormWrapper from '../../components/Registration/RegisterFormWrapper';
import ErrorMessage from '../../interface/ErrorMessage';
import PreloadButton from '../../interface/PreloadButton';
import InputWithCountrySelect from '../../components/UI/InputWithCountrySelect';
import CityAutocomplete from '../../components/Registration/CityAutocomplete';

const PrivateRegister = observer(() => {
    const [phone, setPhone] = useState('');
    const { RegisterStore: { loaderRegister, errorMessage, token, registerPrivate, getCities } = {} } = useStores();

    const nameRef = useRef();
    const emailRef = useRef();

    const register = e => {
        e.preventDefault();
        registerPrivate(nameRef.current.value, phone, emailRef.current.value);
    };

    useEffect(() => getCities(), [getCities]);

    return (
        <RegisterFormWrapper
            icon={`${process.env.REACT_APP_PATH}public/img/users-icon.svg`}
            backArrow={`${process.env.REACT_APP_PATH}public/img/arrow-left.svg`}
            title={loc(RegisterLoc.choose.personal.title)}
        >
            <form onSubmit={register} className="registration-legal-page">
                {token && <Redirect to={{ pathname: '/register/complete/', state: { token } }} />}
                {errorMessage && <ErrorMessage message={errorMessage} />}

                <input ref={nameRef} className="private-form__input" type="name" placeholder={loc(RegisterLoc.form.contactName)} required />

                <InputWithCountrySelect setPhone={setPhone} placeholder={loc(RegisterLoc.form.contactName)} />

                <input ref={emailRef} className="private-form__input" type="email" placeholder={loc(RegisterLoc.form.email)} required />

                <Box mt={2} mb="-30px">
                    <CityAutocomplete />
                </Box>

                <div className="private-form__wrap-btn">
                    <PreloadButton className="private-form__btn" isLoad={loaderRegister}>
                        {loc(RegisterLoc.button)}
                    </PreloadButton>
                </div>
            </form>
        </RegisterFormWrapper>
    );
});

export default PrivateRegister;
